module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("page6...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d908f86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav3/Page6.vue
// module id = 1103
// module chunks = 1